<app-menu></app-menu>

<div class="app-container">
  <app-alert></app-alert>
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
